import { useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import ToastNotification from '../UIElements/ToastNotification';
import useNotification from '../../hooks/useNotification';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteLoginAccount,
  editLoginAccount,
  getAllLoginAccountsDetails,
  newEmailAcountCreation,
} from '../../features/auth/authSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import useConfirmationDialog from '../../hooks/useConfirmationDialog';
import ConfirmationDialog from '../UIElements/ConfirmationDialog';
import { logout } from '../../utils/logout';
const AccountCreation = () => {
  const topRef = useRef(null);
  const [loginDetailsList, setLoginDetailsList] = useState([]);
  const [defaultValues, setDefaultValues] = useState({
    email: '',
    userName: '',
    designation: '',
    role: '',
    password: '',
    mobileNumber: '',
    dashboard: false,
    studentManagement: false,
    payments: false,
    history: false,
    migration: false,
    marks: false,
    attendance: false,
  });
  const dispatch = useDispatch();
  const { userDetails, webServices } = useSelector((state) => {
    return state.auth?.successData ?? {};
  });
  const [loading, setloading] = useState(false);
  const {
    dialog,
    showDeleteConfirmation,
    closeDialog: closeConfirmDialog,
  } = useConfirmationDialog();
  const {
    notification,
    showSuccess,
    showError,
    showWarning,
    hideNotification,
  } = useNotification();
  useEffect(() => {
    getList();
  }, []);
  async function getList() {
    try {
      const response = await dispatch(getAllLoginAccountsDetails()).unwrap();
      if (response) {
        setLoginDetailsList(response);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function deleteAccount(obj) {
    if (obj?.email == userDetails?.email) {
      showWarning("Current logged in user cann't be deleted !");
      closeConfirmDialog();
    } else {
      try {
        const response = await dispatch(deleteLoginAccount(obj.id)).unwrap();
        if (response) {
          showSuccess('Login Account Deleted Successfully');
        }
      } catch (error) {
        showError('Error in Deleting the Login Account');
      } finally {
        closeConfirmDialog();
        getList();
      }
    }
  }
  const goToSection = () => {
    topRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };
  return (
    <>
      {' '}
      <div ref={topRef} className='scroll-mt-28'></div>
      <Formik
        initialValues={defaultValues}
        validationSchema={Yup.object({
          email: Yup.string()
            .email('Invalid Email')
            .required('Email is Required'),
          userName: Yup.string()
            .required('Enter User Name')
            .matches(/^[A-Za-z\s]+$/, 'USer Name must contain only alphabets'),
          designation: Yup.string().required('Enter Designation'),
          role: Yup.string().required('Enter Role'),
          mobileNumber: Yup.string()
            .required('Enter Mobile Number')
            .matches(
              /^[6-9]\d{9}$/,
              'Enter a valid 10-digit Indian mobile number',
            ),
        })}
        enableReinitialize={true}
        onSubmit={async (values, { resetForm }) => {
          setloading(true);
          if (values.role.toLowerCase() === 'admin') {
            values = {
              ...values,
              dashboard: true,
              studentManagement: true,
              payments: true,
              history: true,
              migration: true,
              marks: true,
              attendance: true,
            };
          }
          if (values?.id) {
            try {
              const response = await dispatch(
                editLoginAccount(values),
              ).unwrap();
              if (response?.status === 200) {
                showSuccess(' Login Account modified Sucessfully');

                if (values?.email === userDetails?.email) {
                  alert('Logged in user details are modified,So login agian .');
                  logout();
                }
                resetForm();
              } else {
                showError('Error in Modifiying  Login Account');
              }
            } catch (error) {
              showError('Error in Modifiying  Login Account');
            } finally {
              setloading(false);
            }
          } else {
            try {
              const response = await dispatch(
                newEmailAcountCreation(values),
              ).unwrap();
              if (response?.status === 200) {
                showSuccess('New Login Account Created Sucessfully');
                resetForm();
              } else if (response?.status == 409)
                showError('Email id already exists !');
              else {
                showError('Error in Creating New Login Account');
              }
            } catch (error) {
              showError('Error in Creating New Login Account');
            } finally {
              setloading(false);
            }
          }
          setDefaultValues({
            email: '',
            userName: '',
            designation: '',
            role: '',
            password: '',
            mobileNumber: '',
            dashboard: false,
            studentManagement: false,
            payments: false,
            history: false,
            migration: false,
            marks: false,
            attendance: false,
          });
          getList();
        }}
      >
        {({ values }) => (
          <>
            <Form>
              <Card className='max-w-3xl px-4 py-10'>
                <Typography variant='h6' color='primary' className='mb-4'>
                  Create a New Login Account
                </Typography>
                <div className='grid grid-cols-1 md:grid-cols-2 max-w-2xl gap-4'>
                  {' '}
                  <Field name='userName'>
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        size='small'
                        placeholder='Enter User Name'
                        label='User Name'
                        required
                        onChange={field.onChange}
                        helperText={meta.touched && meta.error}
                        error={meta.touched && Boolean(meta.error)}
                        InputLabelProps={{ shrink: true }}
                      ></TextField>
                    )}
                  </Field>
                  <Field name='designation'>
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        size='small'
                        placeholder='Enter Designaiton'
                        label='Designation'
                        required
                        onChange={field.onChange}
                        helperText={meta.touched && meta.error}
                        error={meta.touched && Boolean(meta.error)}
                        InputLabelProps={{ shrink: true }}
                      ></TextField>
                    )}
                  </Field>
                  <Field name='role'>
                    {({ field, meta }) => (
                      <FormControl
                        fullWidth
                        size='small'
                        required
                        error={meta.touched && Boolean(meta.error)}
                      >
                        <InputLabel
                          id='class-label'
                          shrink={true}
                          className='font-medium'
                        >
                          Role
                        </InputLabel>
                        <Select
                          displayEmpty
                          labelId='class-label'
                          {...field}
                          value={field.value ?? ''}
                          label={'Role'}
                        >
                          {' '}
                          <MenuItem value=''>--Select Role--</MenuItem>
                          <MenuItem value='Admin'> Admin</MenuItem>
                          <MenuItem value='Others'>Others</MenuItem>
                        </Select>
                        {meta.touched && meta.error && (
                          <small className='text-red-600'>{meta.error}</small>
                        )}
                      </FormControl>
                    )}
                  </Field>{' '}
                  <Field name='mobileNumber'>
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        size='small'
                        placeholder='Enter Mobile Number'
                        label='Mobile Number'
                        required
                        onChange={field.onChange}
                        helperText={meta.touched && meta.error}
                        error={meta.touched && Boolean(meta.error)}
                        InputLabelProps={{ shrink: true }}
                      ></TextField>
                    )}
                  </Field>
                  <Field name='email'>
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        size='small'
                        type='email'
                        disabled={values?.id}
                        placeholder='Enter Email'
                        label='Email'
                        required
                        onChange={field.onChange}
                        helperText={meta.touched && meta.error}
                        error={meta.touched && Boolean(meta.error)}
                        InputLabelProps={{ shrink: true }}
                      ></TextField>
                    )}
                  </Field>
                  {!values?.id && (
                    <Field name='password'>
                      {({ field, meta }) => (
                        <TextField
                          {...field}
                          required={!defaultValues?.id}
                          size='small'
                          placeholder='Enter Password'
                          label='Password'
                          onChange={field.onChange}
                          helperText={meta.touched && meta.error}
                          error={meta.touched && Boolean(meta.error)}
                          InputLabelProps={{ shrink: true }}
                        ></TextField>
                      )}
                    </Field>
                  )}
                  {values?.role &&
                    values?.role?.toLocaleLowerCase() === 'admin' && (
                      <div className='flex flex-col gap-1 col-span-1 md:col-span-2'>
                        <div className=' font-semibold'>
                          Note : Admin will have all the Permissions
                        </div>
                        <div>
                          Includes Student Management, Payments, Marks and
                          Attendance
                        </div>
                      </div>
                    )}
                  {values?.role &&
                    values?.role?.toLocaleLowerCase() !== 'admin' && (
                      <div className=' md:col-span-2 '>
                        <Typography variant='body1'>
                          Select Permissions{' '}
                        </Typography>
                        <div className='pl-4'>
                          <Field name='dashboard'>
                            {({ field, form }) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={field.value}
                                      onChange={(e) => {
                                        form.setFieldValue(
                                          field.name,
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  }
                                  label='Dashboard'
                                />
                              </>
                            )}
                          </Field>
                          <Field name='studentManagement'>
                            {({ field, form }) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={field.value}
                                      onChange={(e) => {
                                        form.setFieldValue(
                                          field.name,
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  }
                                  label='Student Management'
                                />
                              </>
                            )}
                          </Field>
                          <Field name='payments'>
                            {({ field, form }) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={field.value}
                                      onChange={(e) =>
                                        form.setFieldValue(
                                          field.name,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  }
                                  label='Payments'
                                />
                              </>
                            )}
                          </Field>
                          <Field name='history'>
                            {({ field, form }) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={field.value}
                                      onChange={(e) =>
                                        form.setFieldValue(
                                          field.name,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  }
                                  label='History'
                                />
                              </>
                            )}
                          </Field>
                          <Field name='migration'>
                            {({ field, form }) => (
                              <>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={field.value}
                                      onChange={(e) =>
                                        form.setFieldValue(
                                          field.name,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  }
                                  label='Migration'
                                />
                              </>
                            )}
                          </Field>
                          {webServices?.webMarks && (
                            <Field name='marks'>
                              {({ field, form }) => (
                                <>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={field.value}
                                        onChange={(e) =>
                                          form.setFieldValue(
                                            field.name,
                                            e.target.checked,
                                          )
                                        }
                                      />
                                    }
                                    label='Marks'
                                  />
                                </>
                              )}
                            </Field>
                          )}
                          {webServices?.webAttendance && (
                            <Field name='attendance'>
                              {({ field, form }) => (
                                <>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={field.value}
                                        onChange={(e) =>
                                          form.setFieldValue(
                                            field.name,
                                            e.target.checked,
                                          )
                                        }
                                      />
                                    }
                                    label='Attendance'
                                  />
                                </>
                              )}
                            </Field>
                          )}
                        </div>
                      </div>
                    )}
                  <div className='ml-auto md:col-span-2'>
                    <Button
                      color='error'
                      variant='outlined'
                      type='reset'
                      onClick={() =>
                        setDefaultValues({
                          email: '',
                          userName: '',
                          designation: '',
                          role: '',
                          password: '',
                          mobileNumber: '',
                          dashboard: false,
                          studentManagement: false,
                          payments: false,
                          history: false,
                          migration: false,
                          marks: false,
                          attendance: false,
                        })
                      }
                    >
                      Clear
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      type='submit'
                      variant='contained'
                      loading={loading}
                      loadingIndicator='Submitting'
                    >
                      {loading ? 'Submitting' : 'Submit'}
                    </Button>
                  </div>
                </div>
              </Card>
            </Form>
            <ToastNotification
              open={notification.open}
              onClose={hideNotification}
              message={notification.message}
              title={notification.title}
              severity={notification.severity}
              autoHideDuration={notification.autoHideDuration}
              position={notification.position}
            />
          </>
        )}
      </Formik>
      <div className='max-w-3xl mt-10'>
        {' '}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            <Typography color='success' className='text-lg'>
              Manage Login Accounts
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              {loginDetailsList?.length == 0 ? (
                <h6 className='text-blue-500 text-center mt-8'>
                  ------No Login Account Available---------
                </h6>
              ) : (
                ''
              )}
            </div>
            {loginDetailsList?.length > 0 && (
              <div className=''>
                <div className='overflow-x-auto grid'>
                  <TableContainer
                    component={Paper}
                    variant='outlined'
                    sx={{
                      maxHeight: 600,
                      overflow: 'auto',
                    }}
                  >
                    <Table stickyHeader size='small' sx={{ minWidth: 600 }}>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                          <TableCell>
                            <strong>SNo.</strong>
                          </TableCell>
                          <TableCell>
                            <strong>User Name</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Designation</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Email</strong>
                          </TableCell>
                          <TableCell align='center'>
                            <strong>Actions</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {loginDetailsList?.map((obj, index) => (
                          <TableRow
                            key={obj?.id}
                            hover
                            sx={{
                              '&:nth-of-type(odd)': {
                                backgroundColor: '#fafafa',
                              },
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>

                            <TableCell className='truncate max-w-[400px] '>
                              <span title={obj?.userName}>
                                {obj?.userName || '--'}
                              </span>
                            </TableCell>
                            <TableCell className='truncate max-w-[400px] '>
                              {obj?.designation || '--'}
                            </TableCell>
                            <TableCell className='truncate max-w-[220px] '>
                              {obj?.email}
                            </TableCell>
                            <TableCell align='center' className='flex gap-2'>
                              <VisibilityOutlinedIcon
                                onClick={() => {
                                  setDefaultValues({ ...obj, password: null });
                                  goToSection();
                                }}
                                className='size-6 hidden'
                              ></VisibilityOutlinedIcon>
                              <EditIcon
                                className='text-blue-400 cursor-pointer text-center'
                                onClick={() => {
                                  setDefaultValues({ ...obj, password: null });
                                  goToSection();
                                }}
                              />
                              <DeleteForeverIcon
                                className='text-red-400 cursor-pointer text-center'
                                onClick={() =>
                                  showDeleteConfirmation(obj?.userName, () =>
                                    deleteAccount(obj),
                                  )
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
      <ConfirmationDialog
        open={dialog.open}
        onClose={closeConfirmDialog}
        onConfirm={dialog.onConfirm}
        title={dialog.title}
        message={dialog.message}
        severity={dialog.severity}
        confirmText={dialog.confirmText}
        cancelText={dialog.cancelText}
        loading={loading}
      />
    </>
  );
};
export default AccountCreation;
